import React from 'react';
import Button from '@atlaskit/button/standard-button';
import { Link } from 'react-router-dom';
import { useSidebar } from '../../hooks';
import { cloudSiteAuditLog, ReservedCloudSite, ReservedCloudSiteSearchRequest } from '@atlassian/cssxp-typescommon';
import { fetchCloudSite, reservedCloudSiteSearchWithName } from '@atlassian/temp-proxies';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import EntitlementIcon from '../../entitlement-icon';
import { PageHeader } from '../../application';
import { ReservedCloudSiteAuditLogs } from './reserved-cloud-site-audit-logs';

interface SidebarProps {
  cloudName?: string;
  cloudSiteData?: ReservedCloudSite;
}

export type Props = SidebarProps;

const CloudSiteSearchSidebarPane = ({ cloudName, cloudSiteData }: Props) => {
  const { closeSidebar } = useSidebar();
  const [auditTrailData, setAuditTrailData] = React.useState<cloudSiteAuditLog[] | null>(null);
  const [isFetchingAuditTrail, setIsFetchingAuditTrail] = React.useState(true);
  const [cloudsiteId, setCloudSiteId] = React.useState('');
  const [cloudSiteUrl, setCloudSiteUrl] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const searchCloudSite = async () => {
    try {
      setIsFetchingAuditTrail(true);
      const requestData: ReservedCloudSiteSearchRequest = {
        cloudName: cloudName?.trim(),
      };
      const response = await reservedCloudSiteSearchWithName(requestData);
      const getCloudSiteId = response?.ARI ? response.ARI?.split('/')?.[1] : '';
      setCloudSiteId(getCloudSiteId);
      if (getCloudSiteId) {
        const result = await fetchCloudSite(getCloudSiteId);
        setCloudSiteUrl(result?.cloudSiteUrl);
      }
      const auditTrials = response?.auditLog ?? [];
      setAuditTrailData(auditTrials);
      setIsFetchingAuditTrail(false);
    } catch (e) {
      setIsFetchingAuditTrail(false);
      //   @ts-ignore
      setError(e.message);
    }
  };

  React.useEffect(() => {
    if (cloudName) {
      searchCloudSite();
    } else {
      setAuditTrailData([]);
      setIsFetchingAuditTrail(false);
    }
  }, [cloudName]);

  return (
    <div style={{ maxWidth: '100%' }}>
      {isFetchingAuditTrail && <LoadingIndicator data-test-id="loading-indicator" />}
      {!isFetchingAuditTrail && (
        <>
          <PageHeader
            icon={<EntitlementIcon productId="atlassian.cloud" className="avatar large" isCloud />}
            header={
              cloudsiteId ? (
                <Link
                  to={`/cloud-sites/${cloudsiteId}`}
                  data-testid="cloudsite-name"
                  onClick={(e) => e.stopPropagation()}
                >
                  {cloudName}
                </Link>
              ) : (
                cloudName
              )
            }
            subheader={
              cloudsiteId ? (
                <>
                  {`Assigned - `}
                  <Link
                    to={`/cloud-sites/${cloudsiteId}`}
                    data-testid="cloudsite-id"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {cloudSiteUrl}
                  </Link>
                  {` (${cloudsiteId})`}
                </>
              ) : (
                `Un-Assigned`
              )
            }
          />
          <ReservedCloudSiteAuditLogs siteData={cloudSiteData} auditLog={auditTrailData} error={error?.toString()} />
          <Button appearance="default" onClick={() => closeSidebar()} testId="closeBtn">
            Close
          </Button>
        </>
      )}
    </div>
  );
};

export default CloudSiteSearchSidebarPane;
